import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { FROM_ORG_SWITCHER_QUERY_PARAM, getOrganisationLink } from '../../../../Utils/NavigationUtils';
import HeaderSearchBar from '../../../../Components/General/HeaderSearchBar';
import debounce from 'lodash-es/debounce';
import { useOrganisationService } from '../../../../Services/OrganisationService';
import { useRequiredOrganisationId } from '../../../../Hooks/UseOrganisationId';
import GradientHighlightButton, { GradientHighlightButtonSide, } from '@cb/solaris-react/Components/Interactive/Button/GradientHighlightButton';
import InlineSpinner from '@cb/solaris-react/Components/Loading/InlineSpinner';
import { Size, Scheme } from '@cb/solaris-react/Constants/System';
import RouterLink from '../../../General/RouterLink';
import ErrorUtils from '../../../../Utils/ErrorUtils';
const MAX_ORGS_SHOWN = 20;
export default function OrganisationSwitcher() {
    const [organisations, setOrganisations] = useState();
    const [error, setError] = useState();
    const [searchFilter, setSearchFilter] = useState();
    const organisationService = useOrganisationService();
    const organisationId = useRequiredOrganisationId();
    useEffect(() => {
        const { data } = organisationService.getOrganisations(MAX_ORGS_SHOWN, searchFilter ? searchFilter : undefined);
        data.then((organisations) => {
            setOrganisations(organisations);
        }).catch((e) => {
            ErrorUtils.handleError(e, 'Failed to load bots', () => {
                setError('Something went wrong fetching organisations, contact support if the issue persists.');
            });
        });
    }, [organisationService, searchFilter]);
    // Search after atleast 250ms of typing
    const debouncedUpdateFilter = useMemo(() => debounce((name) => setSearchFilter(name), 250), []);
    // TODO: Needs error state
    return (_jsxs(Container, { children: [_jsx(HeaderSearchBar, { placeholder: 'Search organisations', onSearchChange: debouncedUpdateFilter, size: Size.small }), error && _jsx("div", { children: error }), _jsx(ScrollingContainer, { children: organisations ? (_jsx("div", { className: "orgs", children: organisations.orgs.map((org) => {
                        return organisationId === org.id ? (_jsx(SelectedOrgButton, { side: GradientHighlightButtonSide.LEFT, selected: true, children: org.name }, org.id)) : (_jsx(OrganisationButton, { onClick: () => organisationService.saveOrganisationIdIntoLocalStorage(org.id), to: `${getOrganisationLink(org.id, '')}?${FROM_ORG_SWITCHER_QUERY_PARAM}=true`, scheme: Scheme.shade7, children: org.name }, org.id));
                    }) })) : (_jsx(InlineSpinner, {})) })] }));
}
const SelectedOrgButton = styled(GradientHighlightButton) `
	background: ${({ theme }) => theme.palette.shade7};
	text-align: left;
`;
const OrganisationButton = styled(RouterLink) `
	text-align: left;
`;
const Container = styled.div `
	flex-grow: 1;
	position: relative;
	width: 100%;
`;
const ScrollingContainer = styled.div `
	position: absolute;
	top: calc(${({ theme }) => theme.sizing.sm} + ${({ theme }) => theme.spacing.sm});
	bottom: 0;
	left: 0;
	right: 0;
	overflow-y: auto;
	${(props) => props.theme.scrollbars.skinny};

	.orgs {
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacing.sm};
	}
`;
//# sourceMappingURL=OrganisationSwitcher.js.map